import React from 'react';
import styled from 'styled-components';
import { HttpStatusBadge, ErrBadge } from './Pills';
import UriLink from './UriLink';

export default function RedirectChain({ elements, crawlStatus }) {
    if (elements === null || elements === undefined) return <Muted>—</Muted>;

    if (!Array.isArray(elements) || elements.length === 0) {
        return <Wrap><ErrBadge title={crawlStatus}>Crawl failed</ErrBadge></Wrap>;
    }

    const steps = [];
    elements.forEach((el, i) => {
        const url = el.sourceURI || (i > 0 ? elements[i - 1].destinationURI : null);
        if (url && (steps.length === 0 || steps[steps.length - 1].url !== url)) {
            steps.push({ url, isSource: steps.length === 0 });
        }
        steps.push({ status: el.httpStatus });
        if (i === elements.length - 1 && el.destinationURI && el.destinationURI !== url) {
            steps.push({ url: el.destinationURI, isFinal: true });
        }
    });

    return (
        <Wrap>
            {steps.map((s, i) =>
                s.url ? (
                    <UrlRow key={i}>
                        <UriLink url={s.url} />
                    </UrlRow>
                ) : (
                    <Step key={i}>
                        <Arrow>{i === steps.length - 1 ? '→' : '↓'}</Arrow>
                        <HttpStatusBadge code={s.status} />
                    </Step>
                )
            )}
        </Wrap>
    );
}

const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 2px 0;
`;

const UrlRow = styled.div`
    display: flex;
    align-items: baseline;
    gap: 6px;
    word-break: break-all;
`;


const Step = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 1px 0;
`;

const Arrow = styled.span`
    font-size: 0.7rem;
    color: #94a3b8;
    flex-shrink: 0;
    margin-left: 6px;
`;


const Muted = styled.span`
    color: #94a3b8;
    font-style: italic;
`;
